
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Integration",
      function () {
        return require("private-next-pages/Integration.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Integration"])
      });
    }
  